/*
* LongTermLease/BookedContainer API
* */
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RejectContainersRequestData,
} from 'app/Apps/OrderManagement/LongTermLease/longTermLease.types'

type BookedContainerRequests = {
    bookContainers: RequestConfigFunction<{id: number, data: any}>,
    rejectContainers: RequestConfigFunction<{
        longTermLeaseId: number,
        data: {rejectedBookedContainers: RejectContainersRequestData[]},
    }>,
    filterRequest: RequestConfigFunction<{longTermLeaseId: number}>,
    containerUsage: RequestConfigFunction<{longTermLeaseId: number}>,
}

const bookedContainerRequests: BookedContainerRequests = {
    bookContainers: ({
        id,
        data,
    }) => {
        return {
            url: `longtermlease/${id}/bookedcontainer`,
            method: 'POST',
            data,
        }
    },
    filterRequest: ({
        longTermLeaseId,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/bookedcontainer/filter-request/all`,
            method: 'POST',
            data: {
                rows: 500,
            },
        }
    },
    rejectContainers: ({
        longTermLeaseId,
        data,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/bookedcontainer/rejection`,
            method: 'PATCH',
            data,
        }
    },
    containerUsage: ({
        longTermLeaseId,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/bookedcontainer/filter-request/container-usage`,
            method: 'POST',
        }
    },
}

export default bookedContainerRequests
